import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class UtilService {
  async getAllCountries() {
    try {
      const response = await service.get(Urls.getApiUrl(`countries`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getStateByCountry(country) {
    try {
      const response = await service.get(Urls.getApiUrl(`states/${country}`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getTimezonesByCountry(country) {
    try {
      const response = await service.get(Urls.getApiUrl(`states/${country}/timeZones`, MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async validateWebsite(website) {
    try {
      const response = await service.post(Urls.getApiUrl(`admin/signup/validate/website`, MICROSERVICES.SESSIONMANAGER), { website: website })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getLoginAttemptsDetails(email) {
    try {
      const response = await service.post(Urls.getApiUrl(`admin/signup/loginattempts`, MICROSERVICES.SESSIONMANAGER),  { email: email })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const utilService = new UtilService()